const state = {
  bcmPage: 1,
  limit: 12,
  name: '',
  mainViewStatus: 1
}

const actions = {
  // 获取数据
  async courseManageGetData({ commit, state }) {
    const page = state.bcmPage
    const data = {
      name: state.name
    }
    if (!data.name) {
      delete data.name
    }
    const res = await API.get(
      `/edu/zone/lesson/offical/packages?page=${page}&limit=12&view_permision=1`,
      data
    )
    return res
  }
}

const mutations = {
  courseManageInit(state) {
    state.bcmPage = 1
    state.name = ''
  }
}

export default {
  state,
  actions,
  mutations
}
